import React, { useMemo } from "react";
import Icon from "../Icon";
import { groupMockSearchResults } from "./mockData";

const MockMainNavbar = ({
    searchQuery = "",
    onSearchChange,
    searchResults = [],
    onSelectResult,
    isSearchOpen = false,
    onSearchFocus,
    onSearchBlur,
    onNavToggle,
    sidebarOpen = false,
}) => {
    const groupedResults = useMemo(() => groupMockSearchResults(searchResults), [searchResults]);
    const showResults = isSearchOpen && searchQuery.trim().length > 0;

    return (
        <div className="clk-mk-navbar">
            {onNavToggle && (
                <button
                    type="button"
                    className="clk-mockup-nav-toggle"
                    onClick={onNavToggle}
                    aria-expanded={sidebarOpen}
                    aria-label="Toggle navigation"
                >
                    <Icon name="menu" size={18} />
                </button>
            )}
            <div className={`clk-mk-navbar-search-wrap${showResults ? " is-open" : ""}`}>
                <div className="clk-mk-navbar-search">
                    <Icon name="search" size={16} />
                    <input
                        type="search"
                        placeholder="Search tickets, users, emails…"
                        aria-label="Search"
                        aria-expanded={showResults}
                        aria-controls="clk-mk-navbar-search-results"
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                        onFocus={onSearchFocus}
                        onBlur={onSearchBlur}
                    />
                </div>
                {showResults && (
                    <div
                        id="clk-mk-navbar-search-results"
                        className="clk-mk-navbar-search-results"
                        role="listbox"
                        aria-label="Search results"
                    >
                        {groupedResults.length === 0 ? (
                            <p className="clk-mk-navbar-search-empty">No results for &ldquo;{searchQuery.trim()}&rdquo;</p>
                        ) : (
                            groupedResults.map((group) => (
                                <div key={group.type} className="clk-mk-navbar-search-group">
                                    <div className="clk-mk-navbar-search-group-label">{group.label}</div>
                                    {group.items.map((item) => (
                                        <button
                                            key={`${item.type}-${item.id}`}
                                            type="button"
                                            className="clk-mk-navbar-search-item"
                                            role="option"
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => onSelectResult(item)}
                                        >
                                            <span>{item.label}</span>
                                            {item.meta && (
                                                <span className="clk-mk-navbar-search-item-meta">{item.meta}</span>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MockMainNavbar;
